export const api = "/xydapi";
